<template>
  <page-header-wrapper>
    <div class="back-content">
      <a-tabs
        class="back-content-tabs"
        :default-active-key="selectedTab"
        :active-key="selectedTab"
        :animated="false"
        @change="tabChange"
      >
        <a-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab.title"
        >
          <component :is="tab.component" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </page-header-wrapper>
</template>

<script>
import PaymentRecord from './paymentRecord/PaymentRecord.vue'
import ResourceSetting from './resourceSetting/ResourceSetting.vue'
// import DetailSetting from './detailSetting/DetailSetting.vue'

const settingTabs = [
  {
    title: '运营年度汇总',
    key: 'resource',
    component: 'ResourceSetting'
  },
  {
    title: '回款记录',
    key: 'record',
    component: 'PaymentRecord'
  }
  // {
  //   title: '详情配置',
  //   key: 'detail',
  //   component: 'DetailSetting'
  // }
]

export default {
  components: {
    PaymentRecord,
    ResourceSetting
    // DetailSetting
  },
  data () {
    return {
      tabs: settingTabs,
      selectedTab: ''
    }
  },
  watch: {
    '$route.query.tab': {
      handler: function (val) {
        this.setSelectedTab()
      }
    }
  },
  created () {
    this.setSelectedTab()
  },
  methods: {
    setSelectedTab () {
      if (this.$route.query && this.$route.query.tab) {
        this.selectedTab = this.$route.query.tab
      } else {
        this.selectedTab = this.tabs[0].key
      }
    },
    tabChange (activeKey) {
      this.$router.push({
        name: 'ResourceSetting',
        query: {
          tab: activeKey
        }
      })
    }
  }
}
</script>
